import React, { useState, useEffect } from 'react';

import Header from '../Header.js';
import Footer from '../Footer.js';
import AgencySettingsBox from '../boxes/AgencySettingsBox.js';
import BoxTabs from '../boxes/BoxTabs.js';

const AgencySettingsPage = ({ user }) => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1600); // screen width cutoff
        };
    
        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Define tabs configuration for different test sections
    const tabs = [
        {
            label: "Tags",
            component: AgencySettingsBox,
            props: { 
                user: user,
                testSections: ['info']
            }
        },
        {
            label: "Checks",
            component: AgencySettingsBox,
            props: { 
                user: user,
                testSections: ['check']
            }
        },
        {
            label: "Narrative Suggestions",
            component: AgencySettingsBox,
            props: { 
                user: user,
                testSections: ['narrative-suggestion']
            }
        },
        {
            label: "Report Suggestions",
            component: AgencySettingsBox,
            props: { 
                user: user,
                testSections: ['report-suggestion']
            }
        },
        {
            label: "Measures",
            component: AgencySettingsBox,
            props: { 
                user: user,
                testSections: ['measure']
            }
        },
        {
            label: "Quantitative Measures",
            component: AgencySettingsBox,
            props: { 
                user: user,
                testSections: ['quant-measure']
            }
        },
        {
            label: "All",
            component: AgencySettingsBox,
            props: { 
                user: user,
                testSections: ['all']
            }
        }
    ];

    return (
        <div>
            <Header 
                user={user} 
                buttonsVisible={{
                    homeButton: true
                }}
                pageTitle="Processing Settings"
            />
            <div className='box-spacer'/>
            <BoxTabs 
                tabs={tabs}
                defaultTabIndex={0}
                isSmallScreen={isSmallScreen}
            />
            <Footer />
        </div>
    );
};

export default AgencySettingsPage; 